export default __webpack_public_path__ + "static/media/alien.5dbb3173.svg";